import React from 'react';
import { Hero } from '../components/Hero';
import { HowItWorks } from '../components/HowItWorks';
import { Benefits } from '../components/Benefits';
import { PatientExperience } from '../components/PatientExperience';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-gradient-to-b from-green-50 to-white" data-id="element-142">
      <Hero data-id="element-143" />
      <HowItWorks data-id="element-144" />
      <Benefits data-id="element-145" />
      <PatientExperience data-id="element-146" />
      <Footer data-id="element-147" />
    </div>;
}